import MarkdownWrapper from './Markdown.styl';

export type MarkdownProps = {
  children?: string;
};

const Markdown = ({children}: MarkdownProps): JSX.Element => {
  return (
    <MarkdownWrapper className="markdown" dangerouslySetInnerHTML={{__html: children as any }}>
    </MarkdownWrapper>
  );
};

export default Markdown;
